import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { websiteLink, websiteLink_new } from "../../helpers/helpers";
import { useSelector } from "react-redux";
import * as paths from "../../constants/paths";
import Cookies from "js-cookie";
import ImageControl from "../common/ImageControl";
import { getAuthUserToken } from "../../helpers/authToken";
export default function DashNav() {
  const memData = useSelector((state) => state.fetchSiteSettings.memData);
  const [active, setActive] = useState(false);
  const token = getAuthUserToken();
  const logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("authToken");
    Cookies.remove("authToken", paths.COOKIE_CONFIG);
    Cookies.remove("authTokenExpiry");
    // Cookies.remove("authToken", { domain: ".ukvisajobs.com", path: "/" });
    // Cookies.remove("authToken", { path: "/" });

    window.location.replace(paths.SITE_BASE_URL + "/signin");
  };
  const [dropDownOne, setDropdownOne] = useState(false);
  const firstDropdown = () => {
    setDropdownOne(!dropDownOne);
  };

  const dropOneRef = useRef();
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (dropOneRef.current && !dropOneRef.current.contains(e.target)) {
        setDropdownOne(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, []);
  const dashboard_articles = useSelector(
    (state) => state.fetchSiteSettings.dashboard_articles
  );
  const activePlan = useSelector((state) => state.fetchSiteSettings.activePlan);

  return (
    <>
      {token ? (
        <nav className="ease">
          <div id="nav" className="">
            <ul id="lst">
              {/* {dashboard_articles?.length > 0 ? (
                <li className="drop">
                  <Link to="javascript:voide(0)">CV Tools</Link>
                  <ul className="sub">
                    {dashboard_articles.map((val) => {
                      return (
                        <li key={val.id}>
                          <Link
                            to={`/article/${val.encoded_id}/${val.slug}`}
                          >
                            <ImageControl folder="images" src={val.image} />
                            {val.title}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </li>
              ) : (
                ""
              )} */}
              {/* <li>
                <Link className="" to="/dashboard">
                  <img
                    src={paths.SITE_BASE_URL + "/images/nav-dash.svg"}
                    alt="doucment image"
                  />
                  <span className="hide_ipad_new_sm">Dashboard</span>
                  <span className="hide_dsk_new_sm">Home</span>
                </Link>
              </li> */}
              {/* <li>
                <Link className="" to={websiteLink("/open-jobs/1")}>
                  <img
                    src={paths.SITE_BASE_URL + "/images/nav-job.svg"}
                    alt="doucment image"
                  />
                  <span>Jobs</span>
                </Link>
              </li> */}
              <li className="jobs_nav">
                <Link
                  className=""
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    websiteLink_new("/open-jobs/1");
                  }}
                >
                  <img
                    src={paths.SITE_BASE_URL + "/images/nav-job.svg"}
                    alt="doucment image"
                  />
                  <span>Jobs</span>
                </Link>
              </li>
              <li>
                <Link
                  className=""
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    websiteLink_new("/explore-companies/1");
                  }}
                >
                  <img
                    src={paths.SITE_BASE_URL + "/images/nav-companies.svg"}
                    alt="doucment image"
                  />
                  <span>Companies</span>
                </Link>
              </li>
              <li>
                <Link className="" to={paths.events_link}>
                  <img
                    src={paths.SITE_BASE_URL + "/images/nav-webinar.svg"}
                    alt="doucment image"
                  />
                  <span>Webinars</span>
                </Link>
              </li>

              <li>
                <Link className="" to={paths.community_link}>
                  <img
                    src={paths.SITE_BASE_URL + "/images/nav-community.svg"}
                    alt="doucment image"
                  />
                  <span>Community</span>
                </Link>
              </li>
              <li>
                <Link className="" to={paths.resources_link}>
                  <img
                    src={paths.SITE_BASE_URL + "/images/nav-resource.svg"}
                    alt="doucment image"
                  />
                  <span>Resources</span>
                </Link>
              </li>
              {/* <li className="hide_ipad_new_sm">
                <Link className="" to={websiteLink("/circle")}>
                  <img
                    src={paths.SITE_BASE_URL + "/images/nav-faq.svg"}
                    alt="doucment image"
                  />
                  <span>Circles</span>
                </Link>
              </li> */}
              {/* <li className="">
                <Link className="" to={paths.faqs_link}>
                  <img
                    src={paths.SITE_BASE_URL + "/images/nav-faq.svg"}
                    alt="doucment image"
                  />
                  <span>FAQs</span>
                </Link>
              </li> */}
              {/* <li className="hide_ipad_new_sm">
                  <Link className="" to="/">
                  <img
                    src="/images/nav-course.svg"
                    alt="doucment image"
                  />
                  <span>Courses</span>
                  </Link>
                </li> */}
              {/* <li className="hide_ipad_new_sm">
                  <Link className="" to="/">
                  <img
                    src="/images/nav-webinar.svg"
                    alt="doucment image"
                  />
                  <span>Webinars</span>
                  </Link>
                </li> */}
              {/* <li>
                  <Link className="" to={paths.PUBLIC_SITE_URL+"events"}>Upcoming Events</Link>
                </li> */}
            </ul>
          </div>
          <div className="right_logged_nav">
            <ul>
              {/* <li>
                <Link to="#">
                  <img
                    src={paths.SITE_BASE_URL + "/images/dash-notify.svg"}
                    alt=""
                  />
                </Link>
              </li> */}
              <li className="drop" onClick={firstDropdown} ref={dropOneRef}>
                <button className="drop_btn">
                  <div className="flex">
                    <div className="img_icon">
                      {/* <ImageControl folder="members" src={memData?.mem_image} /> */}
                      <div className="img_icon">
                        {memData?.mem_image &&
                        memData.mem_image.trim() !== "" ? (
                          <ImageControl
                            folder="members"
                            src={memData.mem_image}
                          />
                        ) : (
                          <img
                            src={paths.SITE_BASE_URL + "/images/frame.svg"}
                            alt={memData?.mem_fname}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="drop_arrow new_arr">
                    <img src="/images/new/arrow-down-filter.svg" alt="" />
                  </div>
                  <div className={dropDownOne ? "drop_cnt active" : "drop_cnt"}>
                    <ul className="drop_lst">
                      <li>
                        <Link to="/dashboard">Dashboard</Link>
                      </li>
                      {/* <li>
                        <Link
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            websiteLink_new("/open-jobs/1?global=true");
                          }}
                        >
                          Global Jobs
                        </Link>
                      </li> */}

                      {/* <li>
                        <Link className="" to={websiteLink_new("/open-jobs/1?global=true")}>Global Jobs</Link>
                      </li> */}

                      <li>
                        <Link to="/my-cvs">My CVs</Link>
                      </li>
                      <li>
                        <Link
                          className=""
                          to={
                            !activePlan ||
                            [4, 9].includes(Number(activePlan?.plan_id))
                              ? "/subscription"
                              : "/job-alerts"
                          }
                        >
                          Job Alerts
                        </Link>
                      </li>

                      {/* <li>
                        <Link className="" to="/job-alerts">
                          Job Alerts
                        </Link>
                      </li> */}
                      <li>
                        <Link className="" to="/ambassador-programme">
                          Ambassador Programme
                        </Link>
                      </li>

                      <li>
                        <Link className="" to="/dashboard-subscription">
                          Subscriptions Management
                        </Link>
                      </li>
                      <li>
                        <Link to="/profile-settings">Account Settings</Link>
                      </li>
                      {/* <li>
                        <a href={paths.help_and_support_link}>Help & Support</a>
                      </li> */}
                      {/* <li>
                        <Link className="" to="/talent-profile">
                          Talent Profile
                        </Link>
                      </li> */}

                      <li>
                        <a href="javascript:void(0)" onClick={logout}>
                          Sign out
                        </a>
                      </li>
                    </ul>
                  </div>
                </button>
              </li>
            </ul>
          </div>
        </nav>
      ) : (
        ""
      )}
    </>
  );
}
